<template>
	<div>
		<div class="dialogBreadCrumbs myDocsBreadcrumbs">
			<ul class="desktopBreadCrumbs">
				<li v-if="currentFolder === null || currentFolder.Parent === null">
					<h2>My Documents</h2>
				</li>
				<ul v-else-if="currentFolder?.Parent !== null && navItems?.length < 4" class="crumbs">
					<li v-for="(item,index) in navItems.slice().reverse()" :key="item.id" :class="{firstListItem: (index == 0)}">
						<a v-if="item.name === ''" class="firstCrumb" @click="handleClick(item.id)">
							<span>My Documents</span>
						</a>
						<a v-else :class="{lastCrumb: index == (navItems.length - 1)}" @click="handleClick(item.id)">
							<span>{{ item.name.replace(/\s/g,'&nbsp;') }}</span>
						</a>
					</li>
				</ul>
				<ul v-else>
					<li class="breadMenu">
						<a />
					</li>
					<ul class="dropdown">
						<li v-for="item in dropDown" :key="item.id" @click="handleClick(item.id)">
							<a v-if="item.name === ''">My Documents</a>
							<a v-else>{{ item.name.replace(/\s/g,'&nbsp;') }}</a>
						</li>
					</ul>
					<ul class="longCrumbs">
						<li v-for="(item,index) in longCrumbs" :key="item.id" :class="{firstListItem: (index == 0)}">
							<a :class="{lastCrumb: (index == (longCrumbs.length - 1)), firstCrumb: (index == 0)}" @click="handleClick(item.id)">
								<span>{{ item.name.replace(/\s/g,'&nbsp;') }}</span>
							</a>
						</li>
					</ul>
				</ul>
			</ul>
		</div>
		<ul class="mobileOnly mobileBreadCrumbs">
			<li v-if="currentFolder?.Parent === null">
				<h2>My Documents</h2>
			</li>
			<li v-else>
				<h2>
					<a @click="handleClick(currentFolder?.Parent?.ItemId)">Go Back</a>
				</h2>
			</li>
		</ul>
	</div>
</template>
<script>
const dialogBreadCrumbs = {
	template: `#dialogBreadCrumbs`,
	emits: [`changeFolder`],
	props: [`currentFolder`, `navItems`],
	computed: {
		dropDown: function () {
			let nav = this.navItems.slice().reverse();
			return nav.splice(0, nav.length - 3).reverse();
		},
		longCrumbs: function () {
			let nav = this.navItems.slice().reverse();
			return nav.splice(nav.length - 3, nav.length - 1);
		},
	},
	methods: {
		handleClick: function (id) {
			if ($(`.dropdown`).hasClass(`show`)) {
				$(`.dropdown`).removeClass(`show`);
				$(`.breadMenu a`).removeClass(`active`);
			}
			this.$emit(`changeFolder`, id);
		},
	},
};

export default dialogBreadCrumbs;
</script>